module.exports = __webpack_public_path__ + "img/pago_fallido.57194744.png";